import type { Params, ThresholdMethod } from '../../lib/types';
import { Slider, Toggle, Select, NumberPair } from './widgets';

export function PreprocessingGroup({ params, setParam }: { params: Params; setParam: <K extends keyof Params>(k: K, v: Params[K]) => void }) {
  return (
    <>
      <NumberPair label="Resize" w={params.resizeWidth} h={params.resizeHeight} lock={params.resizeLockAspect}
        onW={(v) => setParam('resizeWidth', v)} onH={(v) => setParam('resizeHeight', v)} onLock={(v) => setParam('resizeLockAspect', v)} />
      <Toggle label="Auto-trim transparent edges" value={params.autoTrim} onChange={(v) => setParam('autoTrim', v)} />
      <Toggle label="Invert" value={params.invert} onChange={(v) => setParam('invert', v)} />
      <Slider label="Brightness" min={-100} max={100} value={params.brightness} onChange={(v) => setParam('brightness', v)} />
      <Slider label="Contrast" min={-100} max={100} value={params.contrast} onChange={(v) => setParam('contrast', v)} />
      <Slider label="Blur" min={0} max={4} step={1} value={params.blur} onChange={(v) => setParam('blur', v)} />
      {params.mode === 'color' && (
        <Slider label="Posterize" min={2} max={32} step={1} value={params.posterize} onChange={(v) => setParam('posterize', v)} />
      )}
      {params.mode === 'bw' && (
        <Select<ThresholdMethod>
          label="Threshold method"
          value={params.thresholdMethod}
          options={[['manual', 'Manual'], ['otsu', 'Otsu'], ['adaptive', 'Adaptive']]}
          onChange={(v) => setParam('thresholdMethod', v)}
        />
      )}
      <Toggle label="Re-trace SVG inputs (instead of passthrough)" value={params.retraceSvg} onChange={(v) => setParam('retraceSvg', v)} />
    </>
  );
}
